<template>
  <div class="headline">
    <h1><span>{{ firstWord }}</span> {{ secondWord }}</h1>
  </div>
</template>
  
<script>
export default {
  props: {
    pageTitle: {
      type: String,
      required: true
    }
  },
  computed: {
    firstWord() {
      // Splitting the pageTitle string and taking the first word
      return this.pageTitle.split(' ')[0];
    },
    secondWord() {
      // Splitting the pageTitle string and taking the second word onwards
      // Joining them with space in case there are multiple words after the first
      return this.pageTitle.split(' ').slice(1).join(' ');
    }
  }
};
</script>
  
<style lang="scss" scoped>
.headline {
  h1 {
    font-family: "Aktion Mensch Bold";
    font-size: 30px;
    line-height: 38px;
    color: var(--color-text);
    margin-bottom: var(--spacing);
    margin-bottom: 32px;

    span {
      color: var(--color-red);
    }

    @media (max-width: 767px) {
      margin-bottom: 24px;
      font-size: 23px;
      line-height: 29px;
    }
  }
}
</style>
  